import { IconButton, Stack, Typography } from '@mui/material';
import { InboxMessage, Message } from '@schooly/api';
import { AvatarAuth } from '@schooly/components/avatar-auth';
import { RichText } from '@schooly/components/form-rich-text';
import { CrossIcon, ModalContent, ModalHeader, ModalMain } from '@schooly/style';
import { getUserFullName } from '@schooly/utils/user-helpers';
import React from 'react';

import { AttachmentProps } from '../../components/ui/Input/RichText/Attachments/attachment-types';
import { getFormattedPublishDate } from '../../helpers/messages';

type MessagePreviewProps = AttachmentProps & {
  message: Message | InboxMessage;
  onClose: VoidFunction;
};

export const MessagePreview: React.FC<MessagePreviewProps> = ({
  message,
  onClose,
  ...attachmentProps
}) => {
  const { publisher, title } = message as Message;
  const { sender } = message as InboxMessage;

  const senderUser = publisher || sender;

  return (
    <Stack
      sx={{
        height: '100%',
        '.ql-editor': {
          background: 'white !important',
          overflow: 'hidden !important',
          height: '100%',
        },
      }}
    >
      <ModalHeader withBorderBottom title={title} active>
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          <CrossIcon />
        </IconButton>
      </ModalHeader>
      <ModalMain>
        <ModalContent active>
          <Stack direction="row" alignItems="center" gap={1}>
            <AvatarAuth user={sender} sx={{ height: 45, width: 45 }} withAvatarPreview />
            <Stack>
              <Typography variant="h3">{getUserFullName(senderUser)}</Typography>
              <Typography color="common.grey2">{getFormattedPublishDate(message)}</Typography>
            </Stack>
          </Stack>
          <RichText value={message.body} readOnly files={attachmentProps.files} />
        </ModalContent>
      </ModalMain>
    </Stack>
  );
};
